import script from "./AdminCounselling.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCounselling.vue?vue&type=script&setup=true&lang=js"

import "./AdminCounselling.vue?vue&type=style&index=0&id=1366ba29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1366ba29"]])

export default __exports__